import { Form, Input, Modal, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useUpdateThemeSummary } from '../../../api/CodeFrames';

const { TextArea } = Input;

function EditThemeSummaryModal({
  visible,
  closeModal,
  expandSummaryCollapse,
  summary,
  codeFrameId,
  themeId,
  surveyId,
}) {
  const [form] = Form.useForm();
  const { mutate: updateThemeSummary, isLoading: updateThemeSummaryLoading } =
    useUpdateThemeSummary();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ summary });
    }
  }, [form, summary, visible]);

  const onFinish = (values) => {
    updateThemeSummary(
      {
        codeFrameId,
        themeId,
        surveyId,
        data: { summary: values.summary },
      },
      {
        onSuccess: () => message.success('Theme summary updated'),
        onSettled: () => {
          expandSummaryCollapse();
          closeModal();
        },
      },
    );
  };

  return (
    <Modal
      title="Edit theme summary"
      open={visible}
      width={600}
      onOk={() => {
        form
          .validateFields()
          .then(onFinish)
          .catch(() => {});
      }}
      okText="Update"
      onCancel={closeModal}
      confirmLoading={updateThemeSummaryLoading}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          name="summary"
          rules={[
            { required: true, message: 'Theme summary is required' },
            { whitespace: true, message: 'Theme summary cannot be blank' },
          ]}
        >
          <TextArea rows="6" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

EditThemeSummaryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  expandSummaryCollapse: PropTypes.func.isRequired,
  summary: PropTypes.string.isRequired,
  codeFrameId: PropTypes.number.isRequired,
  themeId: PropTypes.number.isRequired,
  surveyId: PropTypes.number.isRequired,
};

export default EditThemeSummaryModal;
